import { render, staticRenderFns } from "./StudentDestinationLogDetails.vue?vue&type=template&id=0565c0c9&scoped=true"
import script from "./StudentDestinationLogDetails.vue?vue&type=script&lang=js"
export * from "./StudentDestinationLogDetails.vue?vue&type=script&lang=js"
import style0 from "./StudentDestinationLogDetails.vue?vue&type=style&index=0&id=0565c0c9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0565c0c9",
  null
  
)

export default component.exports